/**
 * 创建人：zll
 * 时间：2021-10-8
 * 描述：下拉框单选组件的筛选功能(增加汉语、全拼、简拼)
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';


/**
 * 用作下拉框搜索栏
 */
@Pipe({
  name: 'pinyinFilter'
})
export class PinyinFilterPipe implements PipeTransform {

  transform(list: any[],filterField:string,keyword:string): any {///数据源,字段名,关键字
    if(!filterField || !keyword){
        return list;
    }
    //var newlist = []
    var lists = []
    let pinyin = []
    let lowPinyin = []
    let camel = []
    let lowCamel = []
    //汉语
    lists = list.filter(x=>x[filterField].indexOf(keyword)>=0);
    //pinyin
    pinyin = list.filter(x=>x['pinyin'] == keyword);
    //lowPinyin
    lowPinyin = list.filter(x=>x['lowPinyin'] == keyword);
    //camel
    camel = list.filter(x=>x['camel'] == keyword);
    //lowCamel
    lowCamel = list.filter(x=>x['lowCamel'] == keyword);

    if(lists.length > 0){
      return lists
    }
    if(pinyin.length > 0){
      return pinyin
    }
    if(lowPinyin.length > 0){
      return lowPinyin
    }
    if(camel.length > 0){
      return camel
    }
    if(lowCamel.length > 0){
      return lowCamel
    }
   // return newlist
  }
}
